import { MDM_PROPERTIES, MDM_TYPES } from '@/constants/mdm';

import type { AccountProductMdmProperty, NormalizedDataType } from './types';

const ACCOUNT_PRODUCT_PROPERTIES = MDM_PROPERTIES[MDM_TYPES.ACCOUNT_PRODUCT];

export type MappingRowConfig = {
  label: string;
  mdmProperty: AccountProductMdmProperty;
  testId: string;
  required: boolean;
  dataType: NormalizedDataType;
  noOptionsMessage?: string;
};

export const ACCOUNT_PRODUCT_ROWS: MappingRowConfig[] = [
  {
    label: 'Account ID',
    mdmProperty: ACCOUNT_PRODUCT_PROPERTIES.COMPANY_ID,
    testId: 'product-mapping-row-company-id',
    required: true,
    dataType: 'reference',
    noOptionsMessage:
      'This object has no Account lookup Crossbeam can use. Pick another object.',
  },
  {
    label: 'Product Name',
    mdmProperty: ACCOUNT_PRODUCT_PROPERTIES.NAME,
    testId: 'product-mapping-row-name',
    required: true,
    dataType: 'text',
  },
  {
    label: 'Status',
    mdmProperty: ACCOUNT_PRODUCT_PROPERTIES.STATUS,
    testId: 'product-mapping-row-status',
    required: false,
    dataType: 'text',
  },
];

export const ACCOUNT_PRODUCT_SECTIONS = [
  {
    title: 'Required fields',
    rows: ACCOUNT_PRODUCT_ROWS.filter((row) => row.required),
  },
  {
    title: 'Optional',
    rows: ACCOUNT_PRODUCT_ROWS.filter((row) => !row.required),
  },
];
